module.exports = __webpack_public_path__ + "static/media/vertex-9002x-m.34fafba5.jpg";